import {
  ru as attachFaceToCardRu,
  en as attachFaceToCardEn,
  ptBr as attachFaceToCardPtBr,
  esEs as attachFaceToCardEsEs,
} from './attach-face-to-card-button/i18n';
import {
  ruRu as departmentGeneralInfoRuRu,
  en as departmentGeneralInfoEn,
  ptBr as departmentGeneralInfoPtBr,
  esEs as departmentGeneralInfoEsEs,
} from './departments/department-general-info/i18n';
import {
  ruRu as departmentListListRuRu,
  en as departmentListListEn,
  ptBr as departmentListListPtBr,
  esEs as departmentListListEsEs,
} from './departments/department-list-list/i18n';
import {
  ruRu as departmentPermissionTagListRuRu,
  en as departmentPermissionTagListEn,
  ptBr as departmentPermissionTagListPtBr,
  esEs as departmentPermissionTagListEsEs,
} from './departments/department-permission-tag-list/i18n';
import {
  ruRu as departmentStreamGroupListRuRu,
  en as departmentStreamGroupListEn,
  ptBr as departmentStreamGroupListPtBr,
  esEs as departmentStreamGroupListEsEs,
} from './departments/department-stream-group-list/i18n';
import {
  ruRu as departmentUserListRuRu,
  en as departmentUserListEn,
  ptBr as departmentUserListPtBr,
  esEs as departmentUserListEsEs,
} from './departments/department-user-list/i18n';
import {
  ruRu as allMatchesRuRu,
  en as allMatchesEn,
  ptBr as allMatchesPtBr,
  esEs as allMatchesEsEs,
} from './event-details/all-matches/i18n';
import {
  ruRu as eventDetectionRuRu,
  en as eventDetectionEn,
  ptBr as eventDetectionPtBr,
  esEs as eventDetectionEsEs,
} from './event-details/event-detection/i18n';
import {
  ruRu as eventMediaViewerRuRu,
  en as eventMediaViewerEn,
  ptBr as eventMediaViewerPtBr,
  esEs as eventMediaViewerEsEs,
} from './event-details/event-media-viewer/i18n';
import {
  ruRu as topMatchCardRuRu,
  en as topMatchCardEn,
  ptBr as topMatchCardPtBr,
  esEs as topMatchCardEsEs,
} from './event-details/top-match-card/i18n';
import {
  ruRu as topMatchEventRuRu,
  en as topMatchEventEn,
  ptBr as topMatchEventPtBr,
  esEs as topMatchEventEsEs,
} from './event-details/top-match-event/i18n';
import {
  ruRu as topMatchFaceRuRu,
  en as topMatchFaceEn,
  ptBr as topMatchFacePtBr,
  esEs as topMatchFaceEsEs,
} from './event-details/top-match-face/i18n';
import {
  ruRu as permissionTagDepartmentListInfoRuRu,
  en as permissionTagDepartmentListInfoEn,
  ptBr as permissionTagDepartmentListInfoPtBr,
  esEs as permissionTagDepartmentListInfoEsEs,
} from './permission-tag-department-list-info/i18n';
import {
  ru as permissionTagGeneralInfoRuRu,
  en as permissionTagGeneralInfoEn,
  ptBr as permissionTagGeneralInfoPtBr,
  esEs as permissionTagGeneralInfoEsEs,
} from './permission-tag-general-info/i18n';
import {
  ruRu as permissionTagListTableRuRu,
  en as permissionTagListTableEn,
  esEs as permissionTagListTableEsEs,
} from './permission-tag-list-table-viewer/i18n';
import {
  ruRu as permissionTagStreamGroupListInfoRuRu,
  en as permissionTagStreamGroupListInfoEn,
  ptBr as permissionTagStreamGroupListInfoPtBr,
  esEs as permissionTagStreamGroupListInfoEsEs,
} from './permission-tag-stream-group-list-info/i18n';
import {
  ruRu as roleListTableViewerRuRu,
  en as roleListTableViewerEn,
  ptBr as roleListTableViewerPtBr,
  esEs as roleListTableViewerEsEs,
} from './roles/role-list-table-viewer/i18n';
import {
  ruRu as rolePermissionsRuRu,
  en as rolePermissionsEn,
  ptBr as rolePermissionsPtBr,
  esEs as rolePermissionsEsEs,
} from './roles/role-permissions/i18n';
import {
  ruRu as sourceGroupGeneralInfoRuRu,
  en as sourceGroupGeneralInfoEn,
  ptBr as sourceGroupGeneralInfoPtBr,
  esEs as sourceGroupGeneralInfoEsEs,
} from './source-group-general-info/i18n';
import {
  ruRu as sourceGroupInfoRuRu,
  en as sourceGroupInfoEn,
  ptBr as sourceGroupInfoPtBr,
  esEs as sourceGroupInfoEsEs,
} from './source-group-info/i18n';
import {
  ruRu as sourceGroupListViewerRuRu,
  en as sourceGroupListViewerEn,
  ptBr as sourceGroupListViewerPtBr,
  esEs as sourceGroupListViewerEsEs,
} from './source-group-list-viewer/i18n';
import {
  ruRu as sourceGroupSettingsNavRuRu,
  en as sourceGroupSettingsNavEn,
  ptBr as sourceGroupSettingsNavPtBr,
  esEs as sourceGroupSettingsNavEsEs,
} from './source-group-settings-nav/i18n';
import {
  ruRu as sourceGroupStreamSettingsRuRu,
  en as sourceGroupStreamSettingsEn,
  ptBr as sourceGroupStreamSettingsPtBr,
  esEs as sourceGroupStreamSettingsEsEs,
} from './source-group-stream-settings/i18n';
import {
  ruRu as sourceGroupStreamsRuRu,
  en as sourceGroupStreamsEn,
  ptBr as sourceGroupStreamsPtBr,
  esEs as sourceGroupStreamsEsEs,
} from './source-group-streams/i18n';
import {
  ruRu as sourceStreamGeneralInfoRuRu,
  en as sourceStreamGeneralInfoEn,
  ptBr as sourceStreamGeneralInfoPtBr,
  esEs as sourceStreamGeneralInfoEsEs,
} from './source-stream-general-info/i18n';
import {
  ruRu as sourceStreamLastFrameRuRu,
  en as sourceStreamLastFrameEn,
  ptBr as sourceStreamLastFramePtBr,
  esEs as sourceStreamLastFrameEsEs,
} from './source-stream-last-frame/i18n';
import {
  ruRu as sourceStreamSettingsRuRu,
  en as sourceStreamSettingsEn,
  ptBr as sourceStreamSettingsPtBr,
  esEs as sourceStreamSettingsEsEs,
} from './source-stream-settings/i18n';
import {
  ruRu as sourceStreamSettingsNavRuRu,
  en as sourceStreamSettingsNavEn,
  ptBr as sourceStreamSettingsNavPtBr,
  esEs as sourceStreamSettingsNavEsEs,
} from './source-stream-settings-nav/i18n';
import {
  ruRu as userDepartmentListRuRu,
  en as userDepartmentListEn,
  ptBr as userDepartmentListPtBr,
  esEs as userDepartmentListEsEs,
} from './users/user-department-list/i18n';
import {
  ruRu as userDetailsGeneralInfoRuRu,
  en as userDetailsGeneralInfoEn,
  ptBr as userDetailsGeneralInfoPtBr,
  esEs as userDetailsGeneralInfoEsEs,
} from './users/user-details-general-info/i18n';
import {
  ruRu as userListListRuRu,
  en as userListListEn,
  ptBr as userListListPtBr,
  esEs as userListListEsEs,
} from './users/user-list-list/i18n';
import {
  ruRu as userListTableViewerRuRu,
  en as userListTableViewerEn,
  ptBr as userListTableViewerPtBr,
  esEs as userListTableViewerEsEs,
} from './users/user-list-table-viewer/i18n';
import {
  ruRu as userPermissionTagListRuRu,
  en as userPermissionTagListEn,
  ptBr as userPermissionTagListPtBr,
  esEs as userPermissionTagListEsEs,
} from './users/user-permission-tag-list/i18n';
import {
  ruRu as userPermissionsRuRu,
  en as userPermissionsEn,
  ptBr as userPermissionsPtBr,
  esEs as userPermissionsEsEs,
} from './users/user-permissions/i18n';
import {
  ruRu as videoArchiveRuRu,
  en as videoArchiveEn,
  ptBr as videoArchivePtBr,
  esEs as videoArchiveEsEs,
} from './video-archive/i18n';

const widgetsRu = {
  widgets: {
    ...attachFaceToCardRu,
    ...departmentGeneralInfoRuRu,
    ...departmentListListRuRu,
    ...departmentPermissionTagListRuRu,
    ...departmentStreamGroupListRuRu,
    ...departmentUserListRuRu,
    ...roleListTableViewerRuRu,
    ...rolePermissionsRuRu,
    ...userDepartmentListRuRu,
    ...userDetailsGeneralInfoRuRu,
    ...userListListRuRu,
    ...userListTableViewerRuRu,
    ...userPermissionTagListRuRu,
    ...userPermissionsRuRu,
    ...allMatchesRuRu,
    ...eventDetectionRuRu,
    ...eventMediaViewerRuRu,
    ...topMatchCardRuRu,
    ...topMatchEventRuRu,
    ...topMatchFaceRuRu,
    ...permissionTagStreamGroupListInfoRuRu,
    ...permissionTagDepartmentListInfoRuRu,
    ...permissionTagListTableRuRu,
    ...permissionTagGeneralInfoRuRu,
    ...sourceGroupListViewerRuRu,
    ...sourceGroupSettingsNavRuRu,
    ...sourceStreamSettingsNavRuRu,
    ...sourceStreamGeneralInfoRuRu,
    ...sourceStreamSettingsRuRu,
    ...sourceStreamLastFrameRuRu,
    ...sourceGroupStreamsRuRu,
    ...sourceGroupStreamSettingsRuRu,
    ...sourceGroupGeneralInfoRuRu,
    ...sourceGroupInfoRuRu,
    ...videoArchiveRuRu,
  },
};

const widgetsEn = {
  widgets: {
    ...attachFaceToCardEn,
    ...departmentGeneralInfoEn,
    ...departmentListListEn,
    ...departmentPermissionTagListEn,
    ...departmentStreamGroupListEn,
    ...departmentUserListEn,
    ...roleListTableViewerEn,
    ...rolePermissionsEn,
    ...userDepartmentListEn,
    ...userDetailsGeneralInfoEn,
    ...userListListEn,
    ...userListTableViewerEn,
    ...userPermissionTagListEn,
    ...userPermissionsEn,
    ...allMatchesEn,
    ...eventDetectionEn,
    ...eventMediaViewerEn,
    ...topMatchCardEn,
    ...topMatchEventEn,
    ...topMatchFaceEn,
    ...permissionTagStreamGroupListInfoEn,
    ...permissionTagDepartmentListInfoEn,
    ...permissionTagListTableEn,
    ...permissionTagGeneralInfoEn,
    ...sourceGroupListViewerEn,
    ...sourceGroupSettingsNavEn,
    ...sourceStreamSettingsNavEn,
    ...sourceStreamGeneralInfoEn,
    ...sourceStreamSettingsEn,
    ...sourceStreamLastFrameEn,
    ...sourceGroupStreamsEn,
    ...sourceGroupStreamSettingsEn,
    ...sourceGroupGeneralInfoEn,
    ...sourceGroupInfoEn,
    ...videoArchiveEn,
  },
};

const widgetsPtBr = {
  widgets: {
    ...departmentGeneralInfoPtBr,
    ...departmentListListPtBr,
    ...departmentPermissionTagListPtBr,
    ...departmentStreamGroupListPtBr,
    ...departmentUserListPtBr,
    ...roleListTableViewerPtBr,
    ...rolePermissionsPtBr,
    ...userDepartmentListPtBr,
    ...userDetailsGeneralInfoPtBr,
    ...userListListPtBr,
    ...userListTableViewerPtBr,
    ...userPermissionTagListPtBr,
    ...userPermissionsPtBr,
    ...allMatchesPtBr,
    ...eventDetectionPtBr,
    ...eventMediaViewerPtBr,
    ...topMatchCardPtBr,
    ...topMatchEventPtBr,
    ...topMatchFacePtBr,
    ...permissionTagStreamGroupListInfoPtBr,
    ...permissionTagDepartmentListInfoPtBr,
    ...permissionTagListTableEn,
    ...permissionTagGeneralInfoPtBr,
    ...sourceGroupListViewerPtBr,
    ...sourceGroupSettingsNavPtBr,
    ...sourceStreamSettingsNavPtBr,
    ...sourceStreamGeneralInfoPtBr,
    ...sourceStreamSettingsPtBr,
    ...sourceStreamLastFramePtBr,
    ...sourceGroupStreamsPtBr,
    ...sourceGroupStreamSettingsPtBr,
    ...sourceGroupGeneralInfoPtBr,
    ...sourceGroupInfoPtBr,
    ...videoArchivePtBr,
    ...attachFaceToCardPtBr,
  },
};

const widgetsEsEs = {
  widgets: {
    ...departmentGeneralInfoEsEs,
    ...departmentListListEsEs,
    ...departmentPermissionTagListEsEs,
    ...departmentStreamGroupListEsEs,
    ...departmentUserListEsEs,
    ...roleListTableViewerEsEs,
    ...rolePermissionsEsEs,
    ...userDepartmentListEsEs,
    ...userDetailsGeneralInfoEsEs,
    ...userListListEsEs,
    ...userListTableViewerEsEs,
    ...userPermissionTagListEsEs,
    ...userPermissionsEsEs,
    ...allMatchesEsEs,
    ...eventDetectionEsEs,
    ...eventMediaViewerEsEs,
    ...topMatchCardEsEs,
    ...topMatchEventEsEs,
    ...topMatchFaceEsEs,
    ...permissionTagStreamGroupListInfoEsEs,
    ...permissionTagDepartmentListInfoEsEs,
    ...permissionTagListTableEsEs,
    ...permissionTagGeneralInfoEsEs,
    ...sourceGroupListViewerEsEs,
    ...sourceGroupSettingsNavEsEs,
    ...sourceStreamSettingsNavEsEs,
    ...sourceStreamGeneralInfoEsEs,
    ...sourceStreamSettingsEsEs,
    ...sourceStreamLastFrameEsEs,
    ...sourceGroupStreamsEsEs,
    ...sourceGroupStreamSettingsEsEs,
    ...sourceGroupGeneralInfoEsEs,
    ...sourceGroupInfoEsEs,
    ...videoArchiveEsEs,
    ...attachFaceToCardEsEs,
  },
};

export {
  widgetsRu,
  widgetsEn,
  widgetsPtBr,
  widgetsEsEs,
};
